import update from 'immutability-helper';

import {
  GetThreadForListedCompanyDocument,
  GetThreadForListedCompanyQuery,
  SendMessageRequestingGlAccountDataMutation,
  useSendMessageRequestingGlAccountDataMutation
} from 'generated/graphql';
import { DateTime } from 'luxon';
import {
  appFormUtil,
  gqlCacheUtil
} from 'modules/common';
import { useMemo } from 'react';



export type IFrequency = 'quarterly' | 'annual';

export type IFormState = {
  start: Date | null;
  end: Date | null;
  frequency: IFrequency;
  glAccountId: string;
};

export type IFilter = {
  start: DateTime;
  end: DateTime;
  frequency: IFrequency;
  glAccountId: string;
};

export function useQuery() {
  const now = useMemo(() => DateTime.now(), []);
  const form = appFormUtil.useFormState<IFormState>({
    initialState: {
      start: now
        .minus({
          years: 5
        })
        .startOf('year')
        .toJSDate(),
      end: now
        .minus({
          years: 0
        })
        .endOf('year')
        .toJSDate(),

      frequency: 'quarterly',
      glAccountId: ''
    }
  });
  return form;
}



export function useSendMessageRequestingGlAccountData(companyId: string) {
  const [
    sendMessage,
    sendMessageTuple
  ] = useSendMessageRequestingGlAccountDataMutation({
    updateQueries: {
      ...gqlCacheUtil.genUpdateQueryMap<
        GetThreadForListedCompanyQuery,
        SendMessageRequestingGlAccountDataMutation
      >(GetThreadForListedCompanyDocument,
        (prevState, { mutationResult, queryVariables }) => {
          if (queryVariables.listedCompanyId === companyId) {
            const messages = mutationResult.data?.sendMessageRequestingGlAccountData ?? [];

            return update(prevState, {
              messages: prevState.messages
                ? {
                  $push: messages
                }
                : {
                  $set: messages
                }
            });
          }

          return prevState;
        })
    }
  });

  return [
    sendMessage,
    sendMessageTuple
  ] as const;
}
